module.exports = __webpack_public_path__ + "media/Video 142-143.9700608a.mp4";